// extracted by mini-css-extract-plugin
export default {"register-button":"SummerCollegeRuns_register-button__d9EHg"};